export default __webpack_public_path__ + "385e825e7f43e6ed044a7eb012e3e2d3.png";